import { render, staticRenderFns } from "./DoctorComponentModal.vue?vue&type=template&id=2107bc70&scoped=true&"
import script from "./DoctorComponentModal.vue?vue&type=script&lang=js&"
export * from "./DoctorComponentModal.vue?vue&type=script&lang=js&"
import style0 from "./DoctorComponentModal.vue?vue&type=style&index=0&id=2107bc70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107bc70",
  null
  
)

export default component.exports